import React from 'react';
import { Dropdown, Menu as OrcaMenu } from '@fiverr-private/orca';
import { DEFAULT_MENU_CLASS_NAME, DEFAULT_MENU_ITEM_CLASS_NAME } from './constants';
import type { DropdownMenuProps } from './types';

export const DropdownMenu = ({
  trigger,
  menuItems,
  menuClassName = DEFAULT_MENU_CLASS_NAME,
  menuItemClassName = DEFAULT_MENU_ITEM_CLASS_NAME,
}: DropdownMenuProps) => (
  <Dropdown
    position={Dropdown.POSITIONS.RIGHT}
    menu={
      <OrcaMenu className={menuClassName}>
        {/* Orca Menu's children type is "null | undefined" for some reason */}
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-expect-error */}
        <OrcaMenu.Group shouldCloseOnClick>
          {menuItems.map(({ id, name, onClick }) => (
            <OrcaMenu.Item key={id} onClick={onClick} className={menuItemClassName}>
              {name}
            </OrcaMenu.Item>
          ))}
        </OrcaMenu.Group>
      </OrcaMenu>
    }
  >
    {trigger}
  </Dropdown>
);
